export default {
	"7ff8b47d09de677578865f94280a2ea3": "Order placement page",
	"4563606279cf60875f81850e41f27854": "The expanded subject products have been exposed",
	"267203bcd5d649d97969b007ce2c78a1": "\"Expand Subject selection button.",
	"8168a28c7a3d47e4e6f6a677ca145277": "Expand the curriculum and make some changes",
	"cba9a8373ad9a1cb95d95ff1f84ce84a": "Change it."
}
